module.exports = __webpack_public_path__ + "static/media/feature-recommedation-setting@2x.b7dd5690.png";